import { SupabaseJob } from '@applicator/shared'

import { supabase } from '../../lib/supabase'

import { mapSupabaseToJob } from './helpers'

// Helper function to fetch user settings from Supabase
export async function fetchUserSettings(userId: string) {
  const { data, error: fetchError } = await supabase
    .from('user_settings')
    .select('follow_up_days_after_applied, deadline_days_after_saved')
    .eq('user_id', userId)
    .maybeSingle()

  if (fetchError) {
    console.warn('Failed to load user settings (using defaults):', fetchError)
    return null
  }

  return data
}

// Helper function to get current user
export async function getCurrentUser() {
  const { data: { user } } = await supabase.auth.getUser()
  return user
}

// Helper function to handle fetch error
function handleFetchError(fetchError: { message: string }): never {
  throw new Error(fetchError.message)
}

// Helper function to normalize fetched data
function normalizeFetchedData(data: unknown): SupabaseJob[] {
  return (data as SupabaseJob[]) || []
}

export async function fetchJobsFromSupabase(): Promise<SupabaseJob[]> {
  const { data, error: fetchError } = await supabase
    .from('jobs')
    .select('id,title,company,location,salary_max,salary_currency,status,saved_at,deadline_at,applied_at,follow_up_at,excitement,description,date_saved_mode,deadline_mode,date_applied_mode,follow_up_mode,date_saved_manual,deadline_manual,date_applied_manual,follow_up_manual,relevance_score,relevance_verdict,relevance_reasoning,is_relevant,rejected_from_relevant,rejected_reason,rejected_at')
    .order('saved_at', { ascending: false })

  if (fetchError) {
    handleFetchError(fetchError)
  }

  return normalizeFetchedData(data)
}

// Helper function to find job by ID
export function findJobById(mappedJobs: ReturnType<typeof mapSupabaseToJob>[], jobId: string) {
  return mappedJobs.find((j) => j.id === jobId)
}

// Helper function to get first job from list
export function getFirstJob(mappedJobs: ReturnType<typeof mapSupabaseToJob>[]) {
  return mappedJobs.length > 0 ? mappedJobs[0] : undefined
}
